<template>
  <div>
    <transition name="fade">
      <div v-if="!dataLoaded" class="rainbow-spinner">
        <md-progress-spinner class="spinner"  :md-diameter="40" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
      </div>
    </transition>
    <transition name="fade">
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <form v-if="dataLoaded">
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Name, Title & Url</h5>
              </md-card-header>

              <md-card-content>
                <!-- Name -->
                <div class="md-layout">
                  <div class="md-layout-item md-size-33">
                    <md-field
                      :class="[
                        { 'md-error': errors.has('productName') },
                        {
                          'md-valid':
                            !errors.has('productName') && touched.productName
                        }
                      ]"
                    >
                      <label>Product Name</label>
                      <md-input
                        v-model="product.Name"
                        data-vv-name="productName"
                        type="text"
                        v-validate="modelValidations.productName"
                        required
                        @change="productNameChanged()"
                      >
                      </md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="errors.has('productName')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="!errors.has('productName') && touched.productName"
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                  <!-- Meta Title -->
                  <div class="md-layout-item md-size-33">
                    <md-field
                      :class="[
                        { 'md-error': errors.has('productMetaTitle') },
                        {
                          'md-valid':
                            !errors.has('productMetaTitle') &&
                            touched.productMetaTitle
                        }
                      ]"
                    >
                      <label>Meta Title</label>
                      <md-input
                        v-model="product.MetaTitle"
                        data-vv-name="productMetaTitle"
                        type="text"
                        v-validate="modelValidations.productMetaTitle"
                        required
                      >
                      </md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="errors.has('productMetaTitle')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('productMetaTitle') &&
                              touched.productMetaTitle
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                  <!-- Url Identifier -->
                  <div class="md-layout-item md-size-33">
                    <md-field
                      :class="[
                        { 'md-error': errors.has('productUrl') },
                        {
                          'md-valid': !errors.has('productUrl') && touched.productUrl
                        }
                      ]"
                    >
                      <label>Url identifier</label>
                      <md-input
                        v-model="product.UrlTag"
                        data-vv-name="productUrl"
                        type="text"
                        v-validate="modelValidations.productUrl"
                        required
                      >
                      </md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="errors.has('productUrl')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="!errors.has('productUrl') && touched.productUrl"
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Descriptions -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Description</h5>
              </md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <!-- Description -->
                    <md-field
                      :class="[
                        { 'md-error': errors.has('productDescription') },
                        {
                          'md-valid':
                            !errors.has('productDescription') &&
                            touched.productDescription
                        }
                      ]"
                    >
                      <label>Product Description</label>
                      <md-textarea
                        v-model="product.Description"
                        data-vv-name="productDescription"
                        type="text"
                        v-validate="modelValidations.productDescription"
                        required
                        @change="productDescriptionChanged()"
                      ></md-textarea>
                      <slide-y-down-transition>
                        <md-icon
                          class="error"
                          v-show="errors.has('productDescription')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('productDescription') &&
                              touched.productDescription
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                    <!-- Meta Description-->
                  <div class="md-layout-item md-size-50">
                    <md-field
                      :class="[
                        { 'md-error': errors.has('productMetaDescription') },
                        {
                          'md-valid':
                            !errors.has('productMetaDescription') &&
                            touched.productMetaDescription
                        }
                      ]"
                    >
                      <label>Meta Description</label>
                      <md-textarea
                        v-model="product.MetaDescription"
                        data-vv-name="productMetaDescription"
                        type="text"
                        v-validate="modelValidations.productMetaDescription"
                        required
                      ></md-textarea>
                      <slide-y-down-transition>
                        <md-icon
                          class="error"
                          v-show="errors.has('productMetaDescription')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('productMetaDescription') &&
                              touched.productMetaDescription
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Price & Author -->
            <md-card v-if="false">
              <md-card-content class="md-card-content">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-field
                      :class="[
                        { 'md-error': errors.has('productMetaAuthor') },
                        {
                          'md-valid':
                            !errors.has('productMetaAuthor') &&
                            touched.productMetaAuthor
                        }
                      ]"
                    >
                      <label>Meta Author</label>
                      <md-input
                        v-model="product.MetaAuthor"
                        data-vv-name="productMetaAuthor"
                        type="text"
                        v-validate="modelValidations.productMetaAuthor"
                        required
                      >
                      </md-input>
                      <slide-y-down-transition>
                        <md-icon
                          class="error"
                          v-show="errors.has('productMetaAuthor')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('productMetaAuthor') &&
                              touched.productMetaAuthor
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                    <md-field
                      :class="[
                        { 'md-error': errors.has('productPrice') },
                        {
                          'md-valid':
                            !errors.has('productPrice') && touched.productPrice
                        }
                      ]"
                    >
                      <label>Product Price</label>
                      <md-input
                        v-model="product.Price"
                        data-vv-name="productPrice"
                        type="number"
                        v-validate="modelValidations.productPrice"
                        required
                      >
                      </md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="errors.has('productPrice')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="!errors.has('productPrice') && touched.productPrice"
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Category -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Category</h5>
              </md-card-header>
              <md-card-content class="md-card-content">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <md-field :class="[
                        { 'md-error': errors.has('productSection') },
                        {
                          'md-valid':
                            !errors.has('productSection') &&
                            touched.productSection
                        }
                      ]">
                      <label for="movie">Choose category</label>
                      <md-select 
                        v-model="product.SectionId" 
                        data-vv-name="productSection"
                        v-validate="modelValidations.productSection"
                        >
                        <md-option :value="section.Id" v-for="section in sections" :key="section.Id">{{section.Name}}</md-option>
                      </md-select>
                      <slide-y-down-transition>
                        <md-icon
                          class="error"
                          v-show="errors.has('productSection')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('productSection') &&
                              touched.productSection
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Tags -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Tags</h5>
              </md-card-header>
              <md-card-content class="md-card-content">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-chips
                      v-model="product.Categories"
                      class="md-primary"
                      md-placeholder="Enter tag"
                    >
                    </md-chips>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Meta Keywords -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Meta Keywords</h5>
              </md-card-header>
              <md-card-content class="md-card-content">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-chips
                      v-model="product.MetaKeywords"
                      class="md-primary"
                      md-placeholder="Enter keyword"
                      @md-insert="metaKeywordInserted"
                    >
                    </md-chips>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Status -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Status</h5>
              </md-card-header>
              <md-card-content class="md-card-content">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-switch v-model="product.IsActive" @change="isActiveChanged()">
                      <span v-if="product.IsActive"> <b>Active:</b> The product is visible on the products page of vinozito.mk</span>
                      <span v-else> <b>Active:</b> The product is hidden from the products page of vinozito.mk</span>  
                    </md-switch>
                    <md-switch v-model="product.IsFeatured">
                      <span v-if="product.IsFeatured"> <b>Featured:</b> The product is visible on the home page of vinozito.mk</span>
                      <span v-else> <b>Featured:</b> The product is hidden from the home page of vinozito.mk</span>  
                    </md-switch> 
                    
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Photos -->
            <md-card v-if="product.Photos.length">
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Photos</h5>
              </md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 mt-20">
                    <div
                      class="file-input preview-image"
                      v-for="photo in product.Photos"
                      :key="photo.Url"
                    >
                      <div class="image-container">
                        <img :src="photo.Thumbnail || photo.Url" />
                      </div>
                      <div class="button-container">
                        <md-button
                          class="md-xs md-simple md-just-icon "
                          @click="deletePhoto(photo)"
                          ><md-icon>delete</md-icon></md-button
                        >
                        <md-button
                          class="md-success md-xs md-simple md-just-icon"
                          v-if="isCoverPhoto(photo)"
                          ><md-icon>check_circle</md-icon></md-button
                        >
                        <md-button
                          class="md-xs md-simple md-just-icon"
                          v-else
                          @click="setCoverPhoto(photo)">
                          <md-icon>check_circle_outline</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-50 mx-auto">
                    <md-progress-bar v-if="showPhotoLoading" class="md-accent" md-mode="query"></md-progress-bar>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Upload Photos -->
            <md-card>
              <md-card-content class="md-card-content" >
                <div class="md-layout">
                  <div class="md-layout-item md-size-100" style="padding:0;">
                    <vue-dropzone 
                      ref="myVueDropzone" 
                      id="dropzone"
                      :useCustomSlot="true"
                      v-on:vdropzone-files-added="vdropzoneFileAdded" 
                      v-on:vdropzone-success="vdropzoneSuccess"
                      :options="dropzoneOptions">
                        <div class="dropzone-custom-content">
                          <h4 class="dropzone-custom-title">Drag & drop to upload photos</h4>
                          <div class="subtitle">or click to select photos from your computer</div>
                        </div>
                      </vue-dropzone>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Submit Button -->
            <md-card class="md-card md-theme-default">
              <md-card-actions class="text-center">
                <md-button
                  native-type="submit"
                  @click.native.prevent="validate"
                  class="md-primary"
                  :disabled="!canSubmit || saving"
                  >
                  <md-progress-spinner v-if="saving" class="spinner" :md-diameter="20" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
                  <span v-if="saving">&nbsp; Saving</span>
                  <span v-else> Save product</span>
                  </md-button
                >
              </md-card-actions>
            </md-card>
          </form>
        </div>
      </div>
    </transition>

    <!-- Wizard -->
    <modal v-if="showPhotoWizard" class="photo-modal">
      <template slot="body">
        <md-card>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
                <simple-wizard style="width:800px" :nextDisabled="wizardNextDisabled" :saving="wizardSaving">
                  <template slot="header">
                    <h4 class="title">Prepare cover photo thumbnails</h4>
                    <md-button class="md-simple md-just-icon md-round modal-default-button" @click="photoModalHide">
                      <md-icon>clear</md-icon>
                    </md-button>
                   </template>

                  <!-- Step thumbnail -->
                  <wizard-tab :before-change="() => validateStep('step2')">
                    <template slot="label">
                      Thumbnail
                    </template>
                    <cropper
                      classname="cropper"
                      :src="editingPhoto.DataUrl"
                      v-if="editingPhoto"
                      :stencilProps="{
                        aspectRatio: 1 / 1
                      }"
                      @change="thumbChanged"
                    ></cropper>
                  </wizard-tab>
                  
                  <!-- Step social thumbnail-->
                  <wizard-tab :before-change="() => validateStep('step3')">
                    <template slot="label">
                      Social Thumbnail
                    </template>
                    <cropper
                      classname="cropper"
                      :src="editingPhoto.DataUrl"
                      v-if="editingPhoto && wizard.step2.valid"
                      :stencilProps="{
                        aspectRatio: 1.91 / 1
                      }"
                      @change="socialThumbChanged"
                    ></cropper>
                  </wizard-tab>
                </simple-wizard>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </template>
    </modal>
  </div>
</template>

<script>
import { SimpleWizard, WizardTab } from "@/components";
import axios from "axios";
import { Modal } from "@/components";
import { SlideYDownTransition } from "vue2-transitions";
import { Cropper } from "vue-advanced-cropper";

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import cdnInvalidator from "@/services/cdnInvalidator";

export default {
  components: {
    SimpleWizard,
    WizardTab,
    Modal,
    SlideYDownTransition,
    Cropper,
    vueDropzone: vue2Dropzone
  },
  computed: {
    isEdit() {
      return this.productId && this.productId > 0;
    },
    isActive() {
      return this.product.IsActive;
    },
    productId() {
      return this.$route.params.id;
    },
    productName() {
      return this.product.Name;
    },
    productDescription() {
      return this.product.Description;
    },
    productPrice() {
      return this.product.Price;
    },
    productUrl() {
      return this.product.UrlTag;
    },
    productMetaTitle() {
      return this.product.MetaTitle;
    },
    productMetaDescription() {
      return this.product.MetaDescription;
    },
    productSection() {
      return this.product.SectionId;
    },
    productMetaAuthor() {
      return this.product.MetaAuthor;
    },
    canSubmit() {
      return !!(
        !this.errors.has("productName") &&
        !this.errors.has("productDescription") &&
        !this.errors.has("productPrice") &&
        !this.errors.has("productUrl") &&
        !this.errors.has("productMetaTitle") &&
        !this.errors.has("productMetaDescription") &&
        !this.errors.has("productSection") &&
        !this.errors.has("productMetaAuthor") &&
        this.product.SectionId > 0 &&
        this.product.Photos.length &&
        this.product.CoverPhoto &&
        this.product.MetaKeywords.length &&
        this.product.Categories.length
      );
    }
  },
  mounted() {
    axios.get('api/Section').then(sections => {
      this.sections = sections.data
    })
    if (this.isEdit) {
      axios
        .get(`api/Product/${this.productId}`, {
          params: this.filters
        })
        .then(response => {
          this.product = response.data;
        })
        .finally(() => {
           this.dataLoaded = true
        })
    } else {
      this.dataLoaded = true
    }
  },
  data() {
    return {
      sections: [],
      imageRegular: "",
      resizedFiles: {},
      photoButtonLoaders: {1: false, 2: false},
      showPhotoLoading: false,
      saving: false,
      wizardNextDisabled: false,
      wizardSaving: false,
      editingPhoto: {},
      dataLoaded: false,
      showPhotoWizard: false,
      dropzoneOptions: {
        url: (file) => {
          return file[0].Url
        },
        addRemoveLinks: false,
        resizeWidth: 1366,
        resizeHeight: 768,
        resizeQuality: 0.6,
        method: 'put',
        transformFile: this.transformFile,
        autoProcessQueue: false,
        thumbnailWidth: 150,
        maxFilesize: 50,
        headers: { "Content-Type": "image/jpeg" },
        sending: (file, xhr) => {
          var _send = xhr.send;
          xhr.send = () => {
            _send.call(xhr, this.resizedFiles[file.UniqueId]);
          };
        }
      },
      literals: {
        Ё: "YO",
        Й: "I",
        Ц: "C",
        Њ: "NJ",
        У: "U",
        Љ: "LJ",
        љ: "lj",
        Ѕ: "Z",
        ѕ: "z",
        Ѓ: "GJ",
        ѓ: "gj",
        Ќ: "KJ",
        ќ: "kj",
        Џ: "DJ",
        џ: "dj",
        К: "K",
        Ј: "J",
        Е: "E",
        Н: "N",
        Г: "G",
        Ш: "SH",
        Щ: "SCH",
        З: "Z",
        Х: "H",
        Ъ: "'",
        ё: "yo",
        й: "i",
        ц: "c",
        њ: "nj",
        у: "u",
        к: "k",
        е: "e",
        н: "n",
        г: "g",
        ш: "sh",
        щ: "sch",
        з: "z",
        х: "h",
        ъ: "'",
        Ф: "F",
        Ы: "I",
        В: "V",
        А: "a",
        П: "P",
        Р: "R",
        О: "O",
        Л: "L",
        Д: "D",
        Ж: "Z",
        Э: "E",
        ф: "f",
        ы: "i",
        в: "v",
        а: "a",
        п: "p",
        р: "r",
        о: "o",
        л: "l",
        д: "d",
        ж: "z",
        э: "e",
        Я: "Ya",
        Ч: "CH",
        С: "S",
        М: "M",
        И: "I",
        Т: "T",
        Ь: "'",
        Б: "B",
        Ю: "YU",
        я: "ya",
        ч: "ch",
        ј: "j",
        с: "s",
        м: "m",
        и: "i",
        т: "t",
        ь: "'",
        б: "b",
        ю: "yu"
      },
      wizard: {
        uploading: false,
        step1: {
          file: null,
          valid: false
        },
        step2: {
          file: null,
          valid: false
        },
        step3: {
          file: null,
          valid: false
        }
      },
      product: {
        Name: "",
        Description: "",
        MetaTitle: "",
        SectionId: 0,
        CoverPhoto: null,
        MetaDescription: "",
        MetaAuthor: "Frosina Trajkovska",
        UrlTag: "",
        Price: 1000,
        IsActive: true,
        IsFeatured: true,
        MetaKeywords: [],
        Categories: [],
        Photos: []
      },
      touched: {
        productName: false,
        productDescription: false,
        productPrice: false,
        productUrl: false,
        productMetaTitle: false,
        productMetaDescription: false,
        productSection: false,
        productMetaAuthor: false
      },
      modelValidations: {
        productName: {
          required: true,
          min: 5
        },
        productDescription: {
          required: true,
          min: 5
        },
        productPrice: {
          required: true,
          numeric: true,
          min: 1
        },
        productUrl: {
          required: true,
          min: 5
        },
        productMetaTitle: {
          required: true,
          min: 5
        },
        productMetaDescription: {
          required: true,
          min: 5
        },
        productSection: {
          required: true,
          min: 1
        },
        productMetaAuthor: {
          required: true,
          min: 1
        }
      }
    };
  },
  watch: {
    productName() {
      this.touched.productName = true;
    },
    productDescription() {
      this.touched.productDescription = true;
    },
    productPrice() {
      this.touched.productPrice = true;
    },
    productUrl() {
      this.touched.productUrl = true;
    },
    productMetaTitle() {
      this.touched.productMetaTitle = true;
    },
    productMetaDescription() {
      this.touched.productMetaDescription = true;
    },
    productSection() {
      this.touched.productSection = true;
    },
    productMetaAuthor() {
      this.touched.productMetaAuthor = true;
    }
  },
  methods: {
    transformFile (file, done) {
      this.resizePhoto(file, file.type, 1920, 1080).then(resized => {
        fetch(resized)
        .then(res => res.blob())
        .then(blob => {
          file.UniqueId = 'rnd-' + (Math.floor(Math.random() * 999999) + 1)
          this.resizedFiles[file.UniqueId] = blob;
          done(blob)
        })
      })
    },
    vdropzoneFileAdded (files) {
      let promiseArray = Array.from(files).map(file => {
        let prefix = Math.floor(Math.random() * 9999) + 1000;
        return axios
          .get("api/S3/Upload/PresignedUrl", {
            params: { filename: file.name, prefix: prefix, type: 'product' }
          })
          .then(response => {
            file.PublicUrl = response.data.PublicUrl
            file.Url = response.data.Url
          });
      });
      Promise.all(promiseArray).then(() => {
        this.$refs.myVueDropzone.processQueue()
      })
    },
    vdropzoneSuccess(file, response) {
      let photo = {
        Url: file.PublicUrl
      }
      this.product.Photos.push(photo);
      this.$refs.myVueDropzone.removeFile(file)
    },
    deletePhoto(photo) {
      if (!this.isCoverPhoto(photo)) {
        this.product.Photos.splice(this.product.Photos.indexOf(photo), 1);
      }
    },
    transliterate(word) {
      return word
        .split("")
        .map(char => {
          return this.literals[char] || char;
        })
        .join("");
    },
    generateUrl(word) {
      return word
        .trim()
        .split(" ")
        .map(token => token.trim())
        .join("-")
        .toLowerCase()
        .replace(/(-)\1+/g, '$1');
    },
    generateKeywords(word) {
      let cyrilic = word
        .trim()
        .split(" ")
        .map(token => token.trim().toLowerCase())
        .filter(token => token.length > 2);
      let latin = cyrilic.map(w => this.transliterate(w));
      return cyrilic.concat(latin);
    },
    isCoverPhoto(photo) {
      if (!this.product.CoverPhoto) {
        return false
      }
      return (
        (this.isEdit && photo.Id == this.product.CoverPhoto.Id) ||
        (!this.isEdit && photo.Url == this.product.CoverPhoto.Url)
      );
    },
    photoModalHide() {
      this.showPhotoWizard = false;
      this.resetWizard();
    },
    thumbChanged({ coordinates, canvas }) {
      var file = this.getBlobToFile(
        coordinates,
        canvas,
        `thumb.${this.editingPhoto.Name}`,
        this.editingPhoto.Type
      );
      this.wizard.step2.file = file;
    },
    socialThumbChanged({ coordinates, canvas }) {
      var file = this.getBlobToFile(
        coordinates,
        canvas,
        `thumb.social.${this.editingPhoto.Name}`,
        this.editingPhoto.Type
      );
      this.wizard.step3.file = file;
    },
    getBlobToFile(coordinates, canvas, fileName, fileType) {
      var dataUrl = canvas.toDataURL(fileType, 0.9);
      var blobData = this.dataURItoBlob(dataUrl);
      var blobToFile = new File([blobData], fileName, { type: fileType });
      return blobToFile;
    },
    dataURItoBlob(dataURI) {
      var binary = atob(dataURI.split(",")[1]);
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.resetWizard();
      this.wizard.step1.file = files[0];
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        vm.imageRegular = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function() {
      this.resetWizard();
    },
    resetWizard() {
      this.imageRegular = "";
      this.wizard.uploading = false;
      this.wizardSaving = false;
      this.wizardNextDisabled = false;
      this.wizard.step1 = {
        file: null,
        valid: false
      };
      this.wizard.step2 = {
        file: null,
        valid: false
      };
      this.wizard.step3 = {
        file: null,
        valid: false
      };
    },
    validate() {
      this.saving = true
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          let url = "";
          let successMessage = "";
          let method;

          if (this.isEdit) {
            url = `api/Product/${this.productId}`;
            method = axios.put;
            successMessage = "Product successfully updated";
          } else {
            url = "api/Product";
            method = axios.post;
            successMessage = "Product successfully created";
          }

          let payload = this.preparePayload()
          return method(url, payload)
            .then(() => {
              this.invalidateCdn()
              
              this.$notify({
                message: successMessage,
                icon: "check_circle_outline",
                horizontalAlign: "right",
                verticalAlign: "bottom",
                type: "success"
              });
              this.$router.go(-1);
            })
            .catch(errors => {
              console.log(errors)
              errors.forEach(error => {
                this.$notify({
                  message: error,
                  icon: "error_outline",
                  horizontalAlign: "right",
                  verticalAlign: "bottom",
                  type: "danger"
                });
              });
            });
        }
      })
      .finally(() => {
        this.saving = false
      })
    },
    invalidateCdn () {
      if (this.isEdit) {
        cdnInvalidator.onProductDeleteOrUpdate(this.product)
      } else {
        cdnInvalidator.onProductCreate()
      }
    },
    validateStep(step) {
      if (!this.wizard[step].file) {
        return false;
      }

      setTimeout(() => {
        this.wizard[step].valid = true;
      }, 100);

      if (step === "step3" && !this.wizard.uploading) {
        this.startUpload();
      }

      return true;
    },
    startUpload() {
      this.wizardSaving = true;
      this.wizard.uploading = true;
      let file1 = this.wizard.step1.file;
      let file2 = this.wizard.step2.file;
      let file3 = this.wizard.step3.file;
      let photo = {};
      let promiseArray = [];
      //var s3AxiosInstance = axios.create({});
      var s3AxiosInstance = axios.create({
        transformRequest: [
          (data, headers) => {
            delete headers.common.Authorization;
            return data;
          }
        ]
      });
      //delete s3AxiosInstance.defaults.headers.common["Authorization"];

      let prefix = Math.floor(Math.random() * 9999) + 1000;
      
      let promise2 = axios
        .get("api/S3/Upload/PresignedUrl", {
          params: { filename: file2.name, prefix: prefix, type: 'product' }
        })
        .then(response => {
          return this.resizePhoto(file2, file2.type, 1024, 1024).then(resized => {
            let resizedThumbnailFile = this.dataURLtoFile(resized, file2.name);
            return s3AxiosInstance
            .put(response.data.Url, resizedThumbnailFile, {
              headers: {
                "Content-Type": file2.type
              }
            })
              .then(() => {
                this.editingPhoto.Thumbnail = response.data.PublicUrl;
              });
          })
        });

      let promise3 = axios
        .get("api/S3/Upload/PresignedUrl", {
          params: { filename: file3.name, prefix: prefix, type: 'product' }
        })
        .then(response => {
          return this.resizePhoto(file3, file3.type, 1200, 630).then(resized => {
            let resizedThumbnailFile = this.dataURLtoFile(resized, file3.name);
            return s3AxiosInstance
            .put(response.data.Url, resizedThumbnailFile, {
              headers: {
                "Content-Type": file3.type
              }
            })
              .then(() => {
                this.editingPhoto.SocialThumbnail = response.data.PublicUrl;
              });
          })
        });

      promiseArray.push(promise2);
      promiseArray.push(promise3);

      Promise.all(promiseArray)
        .then(() => {
          this.setCoverPhoto(this.editingPhoto)
          this.resetWizard();
          this.showPhotoWizard = false;
          this.editingPhoto = null;
        })
        .finally(() => {
          this.wizard.uploading = false;
        });
    },
    setCoverPhoto(photo) {
      if (photo.Thumbnail) {
        this.product.CoverPhoto = photo
      } else {
        this.editingPhoto = photo
        this.showPhotoCoverBtnLoader();

        var s3AxiosInstance = axios.create({
          transformRequest: [
            (data, headers) => {
              delete headers.common.Authorization;
              return data;
            }
          ]
        });
        s3AxiosInstance
          .get(photo.Url, {
            responseType: 'arraybuffer'
          })
          .then(response => {
            let contentType = response.headers['Content-Type'] ? response.headers['Content-Type'] : 'image/jpeg';

            let buffer = new Buffer(response.data, 'binary');
            let base64 = buffer.toString('base64');
            base64 = `data:${contentType};base64,${base64}`
            let name = photo.Url.split("/").reverse()[0]

              this.editingPhoto.DataUrl = base64
              this.editingPhoto.Name = name
              this.editingPhoto.Type = contentType
              this.showPhotoWizard = true
          })
            .finally(() => {
              this.hidePhotoCoverBtnLoader();
            })
      }
    },
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },
    hidePhotoCoverBtnLoader () {
      this.showPhotoLoading = false;
      this.photoButtonLoaders[this.product.Photos.indexOf(this.editingPhoto)] = false
    },
    showPhotoCoverBtnLoader () {
      this.showPhotoLoading = true;
      this.photoButtonLoaders[this.product.Photos.indexOf(this.editingPhoto)] = true
    },
    isActiveChanged() {
      if (this.product.IsActive === false) {
        this.product.IsFeatured = false;
      }
    },
    productNameChanged() {
      this.product.MetaTitle = this.product.Name;
      let url = this.generateUrl(this.transliterate(this.product.Name));
      this.product.UrlTag = url;
      let keywords = this.generateKeywords(this.product.Name);
      this.product.MetaKeywords = [
        ...new Set(this.product.MetaKeywords.concat(keywords))
      ];
    },
    productDescriptionChanged() {
      this.product.MetaDescription = this.product.Description;
    },
    metaKeywordInserted(value) {
      let transliterated = this.transliterate(value);
      if (this.product.MetaKeywords.indexOf(transliterated) == -1) {
        this.product.MetaKeywords.push(transliterated);
      }
    },
    resizePhoto(file, contentType, maxWidth, maxHeight) {
      return new Promise((resolve, reject) => {
        var canvas = document.createElement("canvas");
        var img = document.createElement("img");
        var reader = new FileReader();  
        reader.onload = function(e) {
          img.onload = function() {
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = maxWidth; //1920;
            var MAX_HEIGHT = maxHeight; //1080;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            var dataurl = canvas.toDataURL(contentType);
            resolve(dataurl)
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(file);
      })
    },
    preparePayload () {
      const withoutDataUrl = photo => {
        let copy = Object.assign({}, photo)
        delete copy.DataUrl
        return copy
      }

      let payload = Object.assign({}, this.product)
      payload.Photos = payload.Photos.map(withoutDataUrl)
      if (payload.CoverPhoto) {
        payload.CoverPhoto = withoutDataUrl(payload.CoverPhoto)
      }
      return payload
    }
  }
};
</script>

<style lang="css">
 .mt-20 {
   margin-top: 20px;
 }
.cropper {
   height: 380px;
   background: #DDD;
 }
 .preview-image .image-container{
   width: 100px;
 }
 .preview-image {
   margin-right: 20px;
   margin-bottom: 10px;
 }
 .photo-modal .modal-container {
  width: 860px;
  max-width: 100%;
  background: transparent;
  box-shadow: none;
 }
 .photo-modal .modal-body {
    width: 0;
    padding: 0;
    margin: 0;
    background: transparent;
 }
 .photo-modal .modal-header {
   padding: 0 !important;
 }
 .photo-modal .md-card-content {
   padding: 0 !important;
 }
 .vue-dropzone {
   border-radius: 6px;
   border: 2px dashed #e5e5e5;
 }
 .dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin: 0;
}
.md-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preview-image .image-container {
  width: 100px;
  height: 100px;
}
textarea {
  padding-left: 0 !important;
}
</style>
